/* eslint-disable react-hooks/exhaustive-deps */
import {useFormik} from 'formik'
import {useEffect, FC, useState, useRef, useMemo} from 'react'
import * as Yup from 'yup'
import CustomLabel, {CustomGroupeLabel} from '../../../../../common/components/label/CustomLabel'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import * as lodash from 'lodash'
import {
  getCountryList,
  getSearchCompanyClient,
  getSearchPersonWorksite,
  getWorkSite,
  getWorkSiteTypeList,
  postWorkSite,
  putWorkSite,
} from '../../core/_requests'
import {DropdownDataType} from '../../core/_models'
import {useNavigate, useParams} from 'react-router-dom'
import {useAuth} from '../../../../auth'
import {toast} from 'react-toastify'
import {Button, Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {
  setIsThereNonSavedForm,
  setProjectEditing,
  setProjectTab1,
  setProjectTab2,
} from '../../../../../common/ModalPopup/reducer'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {CustomGoogleMap} from '../../../../../common/components/Google/googleMap'
import {Required} from '../../../../../common/components/Required/Required'

const initialWorksiteForm = {
  Guid: '',
  ProjectTitle: '',
  CompanyGuid: '',
  CompanyName: '',
  CompanyOther: '',
  CompanyAddress1: '',
  CompanyAddress2: '',
  CompanyAddress3: '',
  CompanyPostalCode: '',
  CompanyCity: '',
  CompanyCountryGuid: '',
  ApplicantGuid: '',
  ApplicantLastname: '',
  ApplicantFirstname: '',
  ApplicantMobile: '',
  ApplicantEmail: '',
  ApplicantPhone: '',
  ApplicantFunction: '',
  FinalApplicantGuid: '',
  FinalApplicantLastname: '',
  FinalApplicantFirstname: '',
  FinalApplicantMobile: '',
  FinalApplicantEmail: '',
  FinalApplicantPhone: '',
  FinalApplicantFunction: '',
  WorkSiteTypeGuid: '',
  WorkSiteTypeOther: '',
  WorkSiteAddress1: '',
  WorkSiteAddress2: '',
  WorkSiteAddress3: '',
  WorkSitePostalCode: '',
  WorkSiteCity: '',
  WorkSiteCountryGuid: '',
  WorkSiteLongitude: '',
  WorkSiteLatitude: '',
}

const npFormValidationSchema2 = Yup.object().shape({
  ProjectTitle: Yup.string()
    .min(5, 'Nom du projet doit avoir au moins 5 caractères')
    .max(255, 'Nom projet est au maximum de 255 caractères')
    .required('Nom du projet est obligatoire'),
  CompanyAddress2: Yup.string()
    .min(5, 'Adresse doit avoir au moins 5 caractères')
    .max(255, 'Adresse est au maximum de 255 caractères')
    .required('Adresse est obligatoire'),
  CompanyPostalCode: Yup.string()
    .min(5, 'Code postal doit avoir au moins 5 caractères')
    .max(20, 'Code postal est au maximum de 20 caractères')
    .required('Code postal est obligatoire'),
  CompanyCity: Yup.string()
    .min(3, 'Ville doit avoir au moins 3 caractères')
    .max(50, 'Ville est au maximum de 50 caractères')
    .required('Ville est obligatoire'),
  WorkSitePostalCode: Yup.string()
    .min(5, 'Minimum 5 caractères')
    .max(20, 'Maximum de 20 caractères')
    .required('Code postal est obligatoire'),
  WorkSiteCity: Yup.string()
    .min(3, 'Minimum 3 caractères')
    .max(50, 'Maximum de 50 caractères')
    .required('Ville est obligatoire'),
  WorkSiteCountryGuid: Yup.string()
    .min(1, 'Minimum 1 caractères')
    .max(256, 'Maximum de 50 caractère')
    .required('Pays est obligatoire'),
  CompanyCountryGuid: Yup.string()
    .min(1, 'Minimum 1 caractère')
    .max(256, 'Maximum de 50 caractères')
    .required('Pays est obligatoire'),
})

type onSubmitProps = {
  onNextClick?: (responseDta: any) => void
  onCancelClick?: () => void
  enabled?: boolean
}

const clearable: any = {
  position: 'absolute',
  right: 36,
  bottom: 0,
}

const NPTab1Form: FC<onSubmitProps> = ({onNextClick, onCancelClick, enabled}) => {
  const {mode, modeSelect} = useThemeMode()
  const isIdemRef: any = useRef()
  const dispatch = useDispatch()
  const {setAuthMessage, logout} = useAuth()
  const {pGuid} = useParams()
  const [initialWsEdit, setInitialWSEdit] = useState<any>(null)
  // const [postWS, setPostWS] = useState<any>(null)
  const [clientDefaultOptions, setClientDefaultOptions] = useState<Array<DropdownDataType>>([])
  const [clientSelected, setClientSelected] = useState<any>(null)
  const [countryOprions, setCountryOptions] = useState<Array<any>>([])
  const [countrySelected, setCountrySelected] = useState<any>(null)
  const [personDefaultOptions, setPersonDefaultOptions] = useState<Array<any>>([])
  const [applicantSelected, setApplicantSelected] = useState<any>(null)
  const [finalApplicantSelected, setFinalApplicantSelected] = useState<any>(null)
  const [wsoptions, setWsoptions] = useState<Array<any>>([])
  const [wsSelected, setWsSelected] = useState<any>(null)
  const [intervCountry, setIntervCountry] = useState<any>(null)
  const [isIdem, setIsIdem] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [showbq, setShowbq] = useState<boolean>(false)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const intl = useIntl()
  const navigate = useNavigate()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  console.log('Submitted', Submitted)
  const validate = (values: any) => {
    console.log(
      'values.WorkSiteTypeGuid values.WorkSiteTypeOther ',
      values.WorkSiteTypeGuid,
      values.WorkSiteTypeOther
    )
    let errors: any = {}
    if (!values.CompanyName && !values.CompanyOther) {
      errors.CompanyName = "L'un des deux est obligatoire (client ou entreprise)"
    }
    if (!values.WorkSiteTypeGuid && !values.WorkSiteTypeOther) {
      errors.WorkSiteTypeGuid = 'Projet est un champ obligatoire'
    } else if (!values.WorkSiteTypeGuid && values.WorkSiteTypeOther === '') {
      errors.WorkSiteTypeGuid = 'Projet est un champ obligatoire'
    } else if (values.WorkSiteTypeGuid === '' && !values.WorkSiteTypeOther) {
      errors.WorkSiteTypeGuid = 'Projet est un champ obligatoire'
    } else if (values.WorkSiteTypeGuid === '' && values.WorkSiteTypeOther === '') {
      errors.WorkSiteTypeGuid = 'Projet est un champ obligatoire'
    }
    if (values.WorkSiteTypeGuid && values.WorkSiteTypeGuid !== '') {
    }
    if (!values.WorkSiteCountryGuid || values.WorkSiteCountryGuid === '') {
      errors.WorkSiteCountryGuid = 'Pays est obligatoire'
    }
    if (!values.CompanyCountryGuid || values.CompanyCountryGuid === '') {
      errors.CompanyCountryGuid = 'Pays est obligatoire'
    }

    if (
      values.ApplicantLastname &&
      values.ApplicantLastname !== '' &&
      values.ApplicantFirstname &&
      values.ApplicantFirstname !== '' &&
      values.ApplicantEmail &&
      values.ApplicantEmail !== '' &&
      values.ApplicantMobile &&
      values.ApplicantMobile !== ''
    ) {
      // errors.ApplicantGuid = null
    } else if (
      !values.ApplicantLastname ||
      !values.ApplicantFirstname ||
      !values.ApplicantEmail ||
      !values.ApplicantMobile ||
      values.ApplicantLastname === '' ||
      values.ApplicantFirstname === '' ||
      values.ApplicantEmail === '' ||
      values.ApplicantMobile === ''
    ) {
      errors.ApplicantGuid = 'Informations du demandeur incomplètes'
    }
    if (
      values.FinalApplicantLastname &&
      values.FinalApplicantLastname !== '' &&
      values.FinalApplicantFirstname &&
      values.FinalApplicantFirstname !== '' &&
      values.FinalApplicantEmail &&
      values.FinalApplicantEmail !== '' &&
      values.FinalApplicantMobile &&
      values.FinalApplicantMobile !== ''
    ) {
    } else if (
      !values.FinalApplicantGuid &&
      (!values.FinalApplicantLastname ||
        !values.FinalApplicantFirstname ||
        !values.FinalApplicantEmail ||
        !values.FinalApplicantMobile ||
        values.FinalApplicantLastname === '' ||
        values.FinalApplicantFirstname === '' ||
        values.FinalApplicantEmail === '' ||
        values.FinalApplicantMobile === '')
    ) {
      errors.FinalApplicantGuid = 'Informations du décideur incomplètes'
    }
    return errors
  }

  const npform2 = useFormik({
    initialValues: initialWorksiteForm,
    validationSchema: npFormValidationSchema2,
    validate: validate,
    onSubmit: async (values) => {
      console.log('values', npform2.isValid, values.CompanyGuid)
      npform2.validateForm()
      if (
        npform2.isValid &&
        ((values.CompanyGuid && values?.CompanyGuid !== '') ||
          (values?.CompanyOther && values?.CompanyOther !== ''))
      ) {
        if (pGuid || projectData?.tab1?.data?.Guid) {
          await putWorkSite(
            values,
            (message: string) => {
              setAuthMessage(message)
              logout()
            },
            ({Message, MessageType, Toast, ToastType}) => {
              // console.log('Message, MessageType, Toast, ToastType', Message, MessageType, Toast, ToastType)
              if (Message && MessageType === 'Success') {
                //
              } else if (Message && MessageType === 'Error') {
                //
              } else if (Toast && ToastType === 'Success') {
                toast(Toast, {type: 'success'})
              } else if (Toast && ToastType === 'Error') {
                toast(Toast, {type: 'error'})
              }
            }
          )
          await loadDefaultData()
          if (!pGuid) {
            navigate('../tab2')
          }
        } else {
          console.log('Post a new project')
          const newWsRes = await postWorkSite(
            values,
            (message: string) => {
              setAuthMessage(message)
              logout()
            },
            ({Message, MessageType, Toast, ToastType}) => {
              if (Message && MessageType === 'Success') {
                //
              } else if (Message && MessageType === 'Error') {
                //
              } else if (Toast && ToastType === 'Success') {
                toast(Toast, {type: 'success'})
              } else if (Toast && ToastType === 'Error') {
                toast(Toast, {type: 'error'})
              }
            }
          )
          if (newWsRes.data.Status.Success && newWsRes.data && newWsRes.data.data) {
            dispatch(
              setProjectTab1({
                data: newWsRes.data.data,
                disabled: false,
                active: false,
              })
            )
            dispatch(
              setProjectTab2({
                ...projectData.tab2,
                disabled: false,
                active: true,
              })
            )
            if (!pGuid) {
              navigate('../tab2')
            }
            await loadDefaultData()
          }
        }
      }
      if (onNextClick && !pGuid) {
        onNextClick({status: 'success'})
      }
    },
  })

  const handleSelectClientchange = async (client: any) => {
    console.log('Selected client', client)
    if (isIdem) {
      isIdemRef?.current?.click()
    }
    npform2.setValues({
      ...npform2.values,
      ...{
        CompanyGuid: client?.Guid || '',
        CompanyName: client?.Name || '',
        CompanyOther: '',
        CompanyAddress1: client?.Address1 || '',
        CompanyAddress2: client?.Address2 || '',
        CompanyAddress3: client?.Address3 || '',
        CompanyPostalCode: client?.PostalCode || '',
        CompanyCity: client?.City || '',
        CompanyCountryGuid: client?.CountryGuid || '',
        ApplicantGuid: '',
        ApplicantLastname: '',
        ApplicantFirstname: '',
        ApplicantMobile: '',
        ApplicantEmail: '',
        ApplicantPhone: '',
        ApplicantFunction: '',
        FinalApplicantGuid: '',
        FinalApplicantLastname: '',
        FinalApplicantFirstname: '',
        FinalApplicantMobile: '',
        FinalApplicantEmail: '',
        FinalApplicantPhone: '',
        FinalApplicantFunction: '',
      },
    })
    setApplicantSelected(null)
    setFinalApplicantSelected(null)
    setIsIdem(false)
    setClientSelected(client)
    if (client?.CountryGuid) {
      const ccCmient = countryOprions?.find((c, ik) => {
        if (client?.CountryGuid === c?.Guid) {
          return 1
        }
        return 0
      })
      if (ccCmient) {
        setCountrySelected(ccCmient)
      }
    }
    if (client) {
      const pDefOpts = await getSearchPersonWorksite(
        {
          Keyword: '',
          CompanyGuid: client.Guid,
          SelectedValueGuid: '',
        },
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (pDefOpts && pDefOpts?.data?.Status?.Success && pDefOpts?.data?.data) {
        setPersonDefaultOptions(
          (pDefOpts?.data?.data || []).map((ko: any) => ({
            ...ko,
            value: ko?.Guid,
            label: ko?.Name,
          }))
        )
      }
    }
  }
  const handleSelectClientContrychange = (country: any) => {
    setCountrySelected(country)
    if (country) {
      npform2.setFieldValue('CompanyCountryGuid', country?.Guid)
    }
  }
  const handleSelectApplicant = (selected: any) => {
    if (selected) {
      if (isIdem) {
        isIdemRef?.current?.click()
      }
      npform2.setFieldValue('ApplicantGuid', selected?.Guid)
      npform2.setFieldValue('ApplicantLastname', selected?.Lastname || '')
      npform2.setFieldValue('ApplicantPhone', selected?.Phone || '')
      npform2.setFieldValue('ApplicantEmail', selected?.Email || '')
      npform2.setFieldValue('ApplicantFirstname', selected?.Firstname || '')
      npform2.setFieldValue('ApplicantFunction', selected?.Function || '')
      npform2.setFieldValue('ApplicantMobile', selected?.Mobile || '')
    } else if (selected == null) {
      npform2.setFieldValue('ApplicantGuid', '')
    }
  }

  const onChangeApplicatWithoutSelect = (e: any) => {
    npform2.setFieldValue(e.target.name, e.target.value)
  }
  const handleSelectFinalApplicant = (selected: any) => {
    if (selected) {
      npform2.setFieldValue('FinalApplicantGuid', selected?.Guid)
      npform2.setFieldValue('FinalApplicantLastname', selected?.Lastname || '')
      npform2.setFieldValue('FinalApplicantPhone', selected?.Phone || '')
      npform2.setFieldValue('FinalApplicantEmail', selected?.Email || '')
      npform2.setFieldValue('FinalApplicantFirstname', selected?.Firstname || '')
      npform2.setFieldValue('FinalApplicantFunction', selected?.Function || '')
      npform2.setFieldValue('FinalApplicantMobile', selected?.Mobile || '')
    } else if (selected == null) {
      npform2.setFieldValue('FinalApplicantGuid', '')
      npform2.setFieldValue('FinalApplicantLastname', '')
      npform2.setFieldValue('FinalApplicantPhone', '')
      npform2.setFieldValue('FinalApplicantEmail', '')
      npform2.setFieldValue('FinalApplicantFirstname', '')
      npform2.setFieldValue('FinalApplicantFunction', '')
      npform2.setFieldValue('FinalApplicantMobile', '')
    }
  }
  const handleSelectTypeConstruction = async (selected: any) => {
    setWsSelected(selected)
    if (selected) {
      await npform2.setFieldValue('WorkSiteTypeOther', '')
      npform2.setFieldValue('WorkSiteTypeGuid', selected?.Guid)
    }
  }
  const handleSelectProjectContrychange = (selected: any) => {
    setIntervCountry(selected)
    if (selected) {
      npform2.setFieldValue('WorkSiteCountryGuid', selected?.Guid)
    }
  }

  const handleCompanyOtherChange = (e: any) => {
    if (isIdem) {
      isIdemRef?.current?.click()
    }
    setCountrySelected(null)
    setApplicantSelected(null)
    setFinalApplicantSelected(null)
    setClientSelected(null)
    setPersonDefaultOptions([])
    npform2.setValues({
      ...npform2.values,
      ...{
        CompanyGuid: '',
        CompanyOther: e.target.value || '',
        CompanyName: '',
        CompanyAddress1: '',
        CompanyAddress2: '',
        CompanyAddress3: '',
        CompanyPostalCode: '',
        CompanyCity: '',
        CompanyCountryGuid: '',
        ApplicantGuid: '',
        ApplicantLastname: '',
        ApplicantFirstname: '',
        ApplicantMobile: '',
        ApplicantEmail: '',
        ApplicantPhone: '',
        ApplicantFunction: '',
        FinalApplicantGuid: '',
        FinalApplicantLastname: '',
        FinalApplicantFirstname: '',
        FinalApplicantMobile: '',
        FinalApplicantEmail: '',
        FinalApplicantPhone: '',
        FinalApplicantFunction: '',
      },
    })
  }

  const onReset = () => {
    if (isThereModif) {
      setShowCancel(true)
    }
  }

  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadDefaultData()
      setShowCancel(false)
    } else {
      npform2?.setValues({...initialWorksiteForm})
      setShowCancel(false)
    }
  }
  const onCancelReset = () => {
    setShowCancel(false)
  }

  const onAccessLost = (message: string) => {
    setAuthMessage(message)
    logout()
  }

  const loadDefaultData = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    let wsObjRes: any = null
    if (Guid) {
      wsObjRes = await getWorkSite(
        {Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (wsObjRes?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(wsObjRes?.data?.Status?.Message)
        return
      }
      if (wsObjRes && wsObjRes?.data?.data) {
        dispatch(setProjectEditing(wsObjRes?.data?.data))
        setInitialWSEdit(wsObjRes?.data?.data)
        npform2.setValues({...wsObjRes?.data?.data})
      }
    }

    const searchClientRes = await getSearchCompanyClient(
      {
        Keyword: '',
        GuidToExclude: '',
        SelectedValueGuid: wsObjRes ? wsObjRes?.data?.data?.CompanyGuid : '',
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (searchClientRes && searchClientRes?.data?.Status?.Success && searchClientRes?.data?.data) {
      setClientDefaultOptions(
        (searchClientRes.data.data || []).map((bg: any) => {
          return {...bg, value: bg?.Guid, label: bg?.Name}
        })
      )
      if (searchClientRes?.data?.SelectedValueData) {
        setClientSelected({
          ...searchClientRes?.data?.SelectedValueData,
          value: searchClientRes?.data?.SelectedValueData?.Guid,
          label: searchClientRes?.data?.SelectedValueData?.Name,
        })
      }
    }

    const countryRes = await getCountryList(
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (countryRes && countryRes?.data?.Status?.Success && countryRes?.data?.data) {
      console.log('countryRes : ', countryRes)
      setCountryOptions(
        (countryRes?.data?.data || []).map((jh: any) => ({
          ...jh,
          value: jh?.Guid,
          label: jh?.Name,
        }))
      )
      if (wsObjRes?.data?.data?.CompanyCountryGuid) {
        const defCountry = (countryRes?.data?.data || []).find((jh: any) => {
          if (wsObjRes?.data?.data?.CompanyCountryGuid === jh?.Guid) {
            return 1
          }
          return 0
        })
        setCountrySelected(
          defCountry ? {...defCountry, value: defCountry?.Guid, label: defCountry?.Name} : null
        )
      }
      if (wsObjRes?.data?.data?.WorkSiteCountryGuid) {
        const sIntC = (countryRes?.data?.data || []).find((jh: any) => {
          if (wsObjRes?.data?.data?.WorkSiteCountryGuid === jh?.Guid) {
            return 1
          }
          return 0
        })
        setIntervCountry(sIntC ? {...sIntC, value: sIntC?.Guid, label: sIntC?.Name} : null)
      }
    }

    const wsRes = await getWorkSiteTypeList(
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )

    if (wsRes && wsRes?.data?.Status?.Success && wsRes?.data?.data) {
      setWsoptions(
        (wsRes?.data?.data || []).map((gt: any) => ({...gt, value: gt?.Guid, label: gt?.Name}))
      )

      if (wsObjRes?.data?.data?.WorkSiteTypeGuid) {
        console.log(
          'wsObjRes?.data?.data?.WorkSiteTypeGuid',
          wsObjRes?.data?.data?.WorkSiteTypeGuid,
          wsRes?.data?.data
        )
        const selectedWS = (wsRes?.data?.data || []).find((gt: any) => {
          if (gt?.Guid === wsObjRes?.data?.data?.WorkSiteTypeGuid) {
            return 1
          }
          return 0
        })
        setWsSelected(
          selectedWS ? {...selectedWS, value: selectedWS?.Guid, label: selectedWS?.Name} : null
        )
      }
    }

    // if (clientSelected || projectData?.tab1?.data) {
    if (wsObjRes?.data?.data?.CompanyGuid && wsObjRes?.data?.data?.CompanyGuid !== '') {
      const pDefOpts = await getSearchPersonWorksite(
        {
          Keyword: '',
          CompanyGuid: wsObjRes?.data?.data?.CompanyGuid,
          SelectedValueGuid: '',
        },
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (pDefOpts && pDefOpts?.data?.Status?.Success && pDefOpts?.data?.data) {
        setPersonDefaultOptions(
          (pDefOpts?.data?.data || []).map((ko: any) => ({
            ...ko,
            value: ko?.Guid,
            label: ko?.Name,
          }))
        )
      }
    }

    if (wsObjRes && wsObjRes?.data?.data?.CompanyGuid && wsObjRes?.data?.data?.CompanyGuid !== '') {
      const persDmdDef = await getSearchPersonWorksite(
        {
          Keyword: '',
          CompanyGuid: wsObjRes?.data?.data?.CompanyGuid,
          SelectedValueGuid: wsObjRes?.data?.data?.ApplicantGuid || '',
        },
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (persDmdDef?.data?.SelectedValueData) {
        setApplicantSelected({
          ...persDmdDef?.data?.SelectedValueData,
          value: persDmdDef?.data?.SelectedValueData?.Guid,
          label: persDmdDef?.data?.SelectedValueData?.Name,
        })
      }
      if (wsObjRes?.data?.data?.CompanyGuid && wsObjRes?.data?.data?.CompanyGuid !== '') {
        const finalPersDmdDef = await getSearchPersonWorksite(
          {
            Keyword: '',
            CompanyGuid: wsObjRes?.data?.data?.CompanyGuid,
            SelectedValueGuid: wsObjRes?.data?.data?.FinalApplicantGuid || '',
          },
          (message: string) => {
            setAuthMessage(message)
            logout()
          },
          ({Message, MessageType, Toast, ToastType}) => {
            if (Message && MessageType === 'Success') {
              //
            } else if (Message && MessageType === 'Error') {
              //
            } else if (Toast && ToastType === 'Success') {
              toast(Toast, {type: 'success'})
            } else if (Toast && ToastType === 'Error') {
              toast(Toast, {type: 'error'})
            }
          }
        )
        if (finalPersDmdDef?.data?.SelectedValueData) {
          setFinalApplicantSelected({
            ...finalPersDmdDef?.data?.SelectedValueData,
            value: finalPersDmdDef?.data?.SelectedValueData?.Guid,
            label: finalPersDmdDef?.data?.SelectedValueData?.Name,
          })
        }
      }
    }
    // }
    setLoading(false)
  }

  const onNextWithoutSaveClick = () => {
    if (isThereModif) {
      setShowbq(true)
    } else {
      navigate('/new-project/tab2' + (pGuid ? '/' + pGuid : ''))
    }
  }

  useEffect(() => {
    if (enabled) loadDefaultData()
  }, [enabled])

  let isThereModif =
    (initialWsEdit && !lodash.isEqual({...npform2.values}, {...initialWsEdit})) ||
    (!initialWsEdit && !lodash.isEqual({...npform2.values}, {...initialWorksiteForm}))
      ? true
      : false
  useMemo(() => {
    dispatch(setIsThereNonSavedForm(isThereModif))
  }, [isThereModif])

  const canClickIsIdem: boolean =
    !npform2?.values?.ApplicantLastname ||
    npform2?.values?.ApplicantLastname === '' ||
    !npform2.values.ApplicantFirstname ||
    npform2.values.ApplicantFirstname === ''

  /*const modeSelect = useMemo(() => {
     return  mode === 'light'
          ? selectCustomStyle
          : {
            ...selectDarkCustomStyle,
            ...selectDarkStyle,
            singleValue: (base: any, props: any) => {
              return {
                ...base,
                color: '#FFF',
                fontWeight: '500',
              }
            },
          }
  },[mode])*/

  return (
    <div data-bs-theme={mode} className={''}>
      <form
        onSubmit={npform2.handleSubmit}
        className={'d-flex p-10 flex-column '}
        data-bs-theme={mode}
      >
        <div className='form-group align-items-center mb-5' data-bs-theme={mode}>
          <div className='d-flex' data-bs-theme={mode}>
            <CustomLabel text={intl.formatMessage({id: 'PROJECT_NAME'})} />
            <Required className='mx-2' styles={{top: -5}} styleIcon={{fontSize: 10}} />
          </div>
          <input
            type='text'
            className='form-control form-control-solid mb-1'
            disabled={Submitted}
            {...npform2.getFieldProps('ProjectTitle')}
          />
          {npform2.touched.ProjectTitle && npform2.errors.ProjectTitle && (
            <div className='is-invalid text-danger' data-bs-theme={mode}>
              {npform2.errors.ProjectTitle}
            </div>
          )}
        </div>
        <div
          data-bs-theme={mode}
          className='gap-5 d-lg-flex d-md-flex d-xl-flex flex-sm-column flex-xl-row justify-content-xl-between justify-content-lg-between justify-content-md-between justify-content-sm-start flex-1'
        >
          <div style={{flex: 0.5}} data-bs-theme={mode}>
            <div data-bs-theme={mode}>
              <div className='d-flex' data-bs-theme={mode}>
                <CustomGroupeLabel text={intl.formatMessage({id: 'CUSTOMER'})} />
                <Required className='mx-2' styles={{top: -5}} styleIcon={{fontSize: 10}} />
              </div>
              <div className='position-relative d-flex ' data-bs-theme={mode}>
                <div className='' style={{flex: 1}}>
                  <div className='w-100 position-relative ' data-bs-theme={mode}>
                    {Submitted ? (
                      <input
                        type='text'
                        className='form-control form-control-solid mb-1'
                        disabled={Submitted}
                        value={clientSelected?.label}
                      />
                    ) : (
                      <AsyncSelect
                        defaultOptions={clientDefaultOptions}
                        loadOptions={async (keyw) => {
                          const data = await getSearchCompanyClient({
                            Keyword: keyw,
                            GuidToExclude: '',
                            SelectedValueGuid: '',
                          })
                          return (data?.data?.data || []).map((bg: any) => {
                            return {...bg, value: bg?.Guid, label: bg?.Name}
                          })
                        }}
                        onChange={handleSelectClientchange}
                        value={clientSelected}
                        styles={modeSelect}
                        isDisabled={Submitted}
                      />
                    )}
                  </div>
                  {clientSelected && !Submitted && (
                    <div
                      className='d-flex align-items-center justify-content-center cursor-pointer p-4'
                      onClick={() => {
                        setClientSelected(null)
                        handleSelectClientchange(null)
                      }}
                      style={{...clearable}}
                    >
                      <i className='fa fa-close text-danger'></i>
                    </div>
                  )}
                </div>
              </div>
              {npform2.touched.CompanyName && npform2.errors.CompanyName && (
                <div className='is-invalid text-danger'>{npform2.errors.CompanyName}</div>
              )}
              <div className='pt-3'>
                <CustomLabel text={intl.formatMessage({id: 'NEW_COMPANY'})} />
                <input
                  type='text'
                  placeholder={intl.formatMessage({id: 'NEW_COMPANY'})}
                  className='form-control form-control-solid fst-italic'
                  {...npform2.getFieldProps('CompanyOther')}
                  onChange={handleCompanyOtherChange}
                  disabled={Submitted}
                />
              </div>
              <CustomLabel
                text={intl.formatMessage({id: 'ONLY_CUSTOMER_DOS_NOT_EXIST'})}
                className='text-gray-500 fw-400 fs-5 mb-5'
              />
              {npform2.errors?.CompanyName && npform2.touched.CompanyName && (
                <div className='is-invalid text-danger'>{npform2.errors.CompanyName}</div>
              )}
            </div>
            <div>
              <CustomGroupeLabel text={intl.formatMessage({id: 'CUSTOMER_COORDINATE'})} />
              <div className='mb-5'>
                <CustomLabel text={intl.formatMessage({id: 'ADDRESS_1'})} />
                <input
                  type='text'
                  placeholder={intl.formatMessage({id: 'ADDRESS_1'})}
                  className='form-control form-control-solid'
                  {...npform2.getFieldProps('CompanyAddress1')}
                  disabled={Submitted}
                />
                {npform2.touched.CompanyAddress1 && npform2.errors.CompanyAddress1 && (
                  <div className='is-invalid text-danger'>{npform2.errors.CompanyAddress1}</div>
                )}
              </div>
              <div>
                <CustomLabel text={intl.formatMessage({id: 'ADDRESS_2'})} />
                <div className='d-flex'>
                  <input
                    type='text'
                    placeholder={intl.formatMessage({id: 'ADDRESS_2'})}
                    className='form-control form-control-solid mb-5'
                    {...npform2.getFieldProps('CompanyAddress2')}
                    disabled={Submitted}
                  />
                  <Required className='mx-2' styles={{top: -5}} />
                </div>
                {npform2.touched.CompanyAddress2 && npform2.errors.CompanyAddress2 && (
                  <div className='is-invalid text-danger'>{npform2.errors.CompanyAddress2}</div>
                )}
              </div>
              <div className='mb-5'>
                <CustomLabel text={intl.formatMessage({id: 'ADDRESS_3'})} />
                <input
                  type='text'
                  placeholder={intl.formatMessage({id: 'ADDRESS_3'})}
                  className='form-control form-control-solid'
                  {...npform2.getFieldProps('CompanyAddress3')}
                  disabled={Submitted}
                />
                {npform2.touched.CompanyAddress3 && npform2.errors.CompanyAddress3 && (
                  <div className='is-invalid text-danger'>{npform2.errors.CompanyAddress3}</div>
                )}
              </div>
              <div className='d-flex justify-content-between flex-1 gap-2'>
                <div style={{flex: 0.3}} className='mb-5'>
                  <CustomLabel text={intl.formatMessage({id: 'POSTAL_CODE'})} />
                  <input
                    type='text'
                    placeholder={intl.formatMessage({id: 'POSTAL_CODE'})}
                    className='form-control form-control-solid'
                    {...npform2.getFieldProps('CompanyPostalCode')}
                    disabled={Submitted}
                  />
                  {npform2.touched.CompanyPostalCode && npform2.errors.CompanyPostalCode && (
                    <div className='is-invalid text-danger'>{npform2.errors.CompanyPostalCode}</div>
                  )}
                </div>
                <Required styles={{top: 10}} />
                <div style={{flex: 0.7}} className='mb-5'>
                  <CustomLabel text={intl.formatMessage({id: 'CITY'})} />
                  <input
                    type='text'
                    placeholder={intl.formatMessage({id: 'CITY'})}
                    className='form-control form-control-solid'
                    {...npform2.getFieldProps('CompanyCity')}
                    disabled={Submitted}
                  />
                  {npform2.touched.CompanyCity && npform2.errors.CompanyCity && (
                    <div className='is-invalid text-danger'>{npform2.errors.CompanyCity}</div>
                  )}
                </div>
                <Required className='gap-5' styles={{top: 10}} />
              </div>
              <div className='d-flex'>
                <div className='d-flex align-items-center pb-5' style={{flex: 1}}>
                  <div style={{flex: 1}}>
                    <CustomLabel text={intl.formatMessage({id: 'STATE'})} />
                    <div className='w-100 position-relative ' data-bs-theme={mode}>
                      {Submitted ? (
                        <input
                          type='text'
                          placeholder={intl.formatMessage({id: 'STATE'})}
                          value={applicantSelected?.label || ''}
                          className='form-control form-control-solid'
                        />
                      ) : (
                        <Select
                          className='form-select-solid custom-select'
                          options={countryOprions}
                          onChange={handleSelectClientContrychange}
                          value={countrySelected}
                          styles={modeSelect}
                          isDisabled={Submitted}
                        />
                      )}
                      {countrySelected && !Submitted && (
                        <div
                          className='d-flex align-items-center justify-content-center cursor-pointer p-4'
                          onClick={() => {
                            setCountrySelected(null)
                            npform2.setFieldValue('CompanyCountryGuid', '')
                          }}
                          style={clearable}
                        >
                          <i className='fa fa-close text-danger'></i>
                        </div>
                      )}
                    </div>
                    {npform2.errors.CompanyCountryGuid && (
                      <div className='is-invalid text-danger'>
                        {npform2.errors.CompanyCountryGuid}
                      </div>
                    )}
                  </div>
                </div>
                <Required styles={{top: 30, left: 5}} />
              </div>
            </div>
            <div>
              <div className='d-flex'>
                <CustomGroupeLabel text={intl.formatMessage({id: 'ASKER'})} />
                <Required className='mx-2' styles={{top: -5}} />
              </div>
              <div>
                <div className='d-flex align-items-center'>
                  <div style={{flex: 1}}>
                    <div className='w-100 position-relative ' data-bs-theme={mode}>
                      {Submitted ? (
                        <input
                          type='text'
                          placeholder={intl.formatMessage({id: 'ASKER'})}
                          value={applicantSelected?.label || ''}
                          className='form-control form-control-solid'
                        />
                      ) : (
                        <AsyncSelect
                          className='form-select-solid'
                          value={applicantSelected}
                          defaultOptions={personDefaultOptions}
                          loadOptions={async (keyw) => {
                            if (!clientSelected) return []
                            const pDefOpts = await getSearchPersonWorksite({
                              Keyword: keyw,
                              CompanyGuid: clientSelected?.Guid,
                              SelectedValueGuid: '',
                            })
                            if (
                              pDefOpts &&
                              pDefOpts?.data?.Status?.Success &&
                              pDefOpts?.data?.data
                            ) {
                              return (pDefOpts?.data?.data || []).map((ko: any) => ({
                                ...ko,
                                value: ko?.Guid,
                                label: ko?.Name,
                              }))
                            }
                          }}
                          onChange={(newValue) => {
                            setApplicantSelected(newValue)
                            handleSelectApplicant(newValue)
                          }}
                          styles={modeSelect}
                          isDisabled={Submitted}
                        />
                      )}
                    </div>
                  </div>
                  {applicantSelected && !Submitted && (
                    <div
                      className='d-flex align-items-center justify-content-center cursor-pointer p-4'
                      onClick={() => {
                        if (isIdem) {
                          isIdemRef?.current?.click()
                        }

                        setApplicantSelected(null)
                        handleSelectApplicant(null)
                        npform2.setFieldValue('ApplicantGuid', '')
                        npform2.setFieldValue('ApplicantLastname', '')
                        npform2.setFieldValue('ApplicantPhone', '')
                        npform2.setFieldValue('ApplicantEmail', '')
                        npform2.setFieldValue('ApplicantFirstname', '')
                        npform2.setFieldValue('ApplicantFunction', '')
                        npform2.setFieldValue('ApplicantMobile', '')
                        setFinalApplicantSelected(null)
                      }}
                      style={clearable}
                    >
                      <i className='fa fa-close text-danger'></i>
                    </div>
                  )}
                </div>
                {npform2.touched.ApplicantGuid && npform2.errors.ApplicantGuid && (
                  <div className='is-invalid text-danger'>{npform2.errors.ApplicantGuid}</div>
                )}
              </div>
              <div className='d-flex justify-content-between flex-1 gap-5 mt-5'>
                <div style={{flex: 0.5}}>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'LASTNAME'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'LASTNAME'})}
                      className='form-control form-control-solid'
                      //{...npform2.getFieldProps('ApplicantLastname')}
                      name='ApplicantLastname'
                      value={npform2.values?.ApplicantLastname}
                      onChange={onChangeApplicatWithoutSelect}
                      disabled={Submitted}
                    />
                    {npform2.touched.ApplicantLastname && npform2.errors.ApplicantLastname && (
                      <div className='is-invalid text-danger'>
                        {npform2.errors.ApplicantLastname}
                      </div>
                    )}
                  </div>
                  <div className='mb-5'>
                    <CustomLabel text={intl.formatMessage({id: 'PHONE_NUMBER'})} />
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'PHONE_NUMBER'})}
                      className='form-control form-control-solid'
                      //{...npform2.getFieldProps('ApplicantPhone')}
                      name='ApplicantPhone'
                      value={npform2.values?.ApplicantPhone}
                      onChange={onChangeApplicatWithoutSelect}
                      disabled={Submitted}
                    />
                    {npform2.touched.ApplicantPhone && npform2.errors.ApplicantPhone && (
                      <div className='is-invalid text-danger'>{npform2.errors.ApplicantPhone}</div>
                    )}
                  </div>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'EMAIL'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'EMAIL'})}
                      className='form-control form-control-solid'
                      //{...npform2.getFieldProps('ApplicantEmail')}
                      name='ApplicantEmail'
                      value={npform2.values?.ApplicantEmail}
                      onChange={onChangeApplicatWithoutSelect}
                      disabled={Submitted}
                    />
                    {npform2.touched.ApplicantEmail && npform2.errors.ApplicantEmail && (
                      <div className='is-invalid text-danger'>{npform2.errors.ApplicantEmail}</div>
                    )}
                  </div>
                </div>
                <div style={{flex: 0.5}}>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'FIRSTNAME'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'FIRSTNAME'})}
                      className='form-control form-control-solid'
                      //{...npform2.getFieldProps('ApplicantFirstname')}
                      name='ApplicantFirstname'
                      value={npform2.values?.ApplicantFirstname}
                      onChange={onChangeApplicatWithoutSelect}
                      disabled={Submitted}
                    />
                    {npform2.touched.ApplicantFirstname && npform2.errors.ApplicantFirstname && (
                      <div className='is-invalid text-danger'>
                        {npform2.errors.ApplicantFirstname}
                      </div>
                    )}
                  </div>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'MOBILE_PHONE'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'MOBILE_PHONE'})}
                      className='form-control form-control-solid'
                      //{...npform2.getFieldProps('ApplicantMobile')}
                      name='ApplicantMobile'
                      value={npform2.values?.ApplicantMobile}
                      onChange={onChangeApplicatWithoutSelect}
                      disabled={Submitted}
                    />
                    {npform2.touched.ApplicantMobile && npform2.errors.ApplicantMobile && (
                      <div className='is-invalid text-danger'>{npform2.errors.ApplicantMobile}</div>
                    )}
                  </div>
                  <div className='mb-5'>
                    <CustomLabel text={intl.formatMessage({id: 'WORK_FUNCTION'})} />
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'WORK_FUNCTION'})}
                      className='form-control form-control-solid'
                      // {...npform2.getFieldProps('ApplicantFunction')}
                      name='ApplicantFunction'
                      value={npform2.values?.ApplicantFunction}
                      onChange={onChangeApplicatWithoutSelect}
                      disabled={Submitted}
                    />
                    {npform2.touched.ApplicantFunction && npform2.errors.ApplicantFunction && (
                      <div className='is-invalid text-danger'>
                        {npform2.errors.ApplicantFunction}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className='gap-5 d-lg-flex d-md-flex d-xl-flex flex-sm-column flex-xl-row justify-content-xl-between justify-content-lg-between justify-content-md-between justify-content-sm-start flex-1'>
                <div style={{flex: 0.7}}>
                  <CustomGroupeLabel text={intl.formatMessage({id: 'FINAL_APPLICATNT_IF_NO'})} />
                </div>
                <div
                  // style={{flex: 0.3}}
                  className='form-check form-check-custom form-check-solid text-end mb-xl-0 mb-lg-3 mb-md-3 mb-sm-3 mb-3'
                  data-bs-theme={mode}
                >
                  <input
                    className='form-check-input fs-3 '
                    data-bs-theme={mode}
                    type='checkbox'
                    ref={isIdemRef}
                    // checked={isIdem}
                    disabled={(!applicantSelected && canClickIsIdem) || Submitted}
                    style={{backgroundColor: isIdem ? '#e2423a' : '#9A9A9A'}}
                    onChange={(e) => {
                      // e.preventDefault()
                      // const newIdem = !isIdem

                      if (e.target.checked) {
                        // setIsIdem(true)
                        npform2.setFieldValue('FinalApplicantGuid', npform2.values?.ApplicantGuid)
                        npform2.setFieldValue(
                          'FinalApplicantLastname',
                          npform2.values?.ApplicantLastname
                        )
                        npform2.setFieldValue(
                          'FinalApplicantFirstname',
                          npform2.values?.ApplicantFirstname
                        )
                        npform2.setFieldValue(
                          'FinalApplicantMobile',
                          npform2.values?.ApplicantMobile
                        )
                        npform2.setFieldValue('FinalApplicantEmail', npform2.values?.ApplicantEmail)
                        npform2.setFieldValue('FinalApplicantPhone', npform2.values?.ApplicantPhone)
                        npform2.setFieldValue(
                          'FinalApplicantFunction',
                          npform2.values?.ApplicantFunction
                        )
                        setFinalApplicantSelected(applicantSelected)
                      } else {
                        // setIsIdem(false)
                        npform2.setFieldValue('FinalApplicantGuid', '')
                        npform2.setFieldValue('FinalApplicantLastname', '')
                        npform2.setFieldValue('FinalApplicantFirstname', '')
                        npform2.setFieldValue('FinalApplicantMobile', '')
                        npform2.setFieldValue('FinalApplicantEmail', '')
                        npform2.setFieldValue('FinalApplicantPhone', '')
                        npform2.setFieldValue('FinalApplicantFunction', '')
                        setFinalApplicantSelected(null)
                      }
                      setIsIdem(e.target.checked)
                    }}
                  />
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'SAME_AS_APPLICANT'})}
                  </label>
                </div>
              </div>
              <div className='d-flex align-items-center'>
                <div style={{flex: 1}}>
                  <div className='w-100 position-relative ' data-bs-theme={mode}>
                    {Submitted ? (
                      <input
                        type='text'
                        placeholder={intl.formatMessage({id: 'SAME_AS_APPLICANT'})}
                        value={finalApplicantSelected?.label || ''}
                        className='form-control form-control-solid'
                      />
                    ) : (
                      <AsyncSelect
                        className='form-select-solid'
                        value={finalApplicantSelected}
                        defaultOptions={personDefaultOptions}
                        isDisabled={isIdem || Submitted}
                        loadOptions={async (keyw) => {
                          if (!clientSelected) return []
                          const pDefOpts = await getSearchPersonWorksite({
                            Keyword: keyw,
                            CompanyGuid: clientSelected?.Guid,
                            SelectedValueGuid: '',
                          })
                          if (pDefOpts && pDefOpts?.data?.Status?.Success && pDefOpts?.data?.data) {
                            return (pDefOpts?.data?.data || []).map((ko: any) => ({
                              ...ko,
                              value: ko?.Guid,
                              label: ko?.Name,
                            }))
                          }
                        }}
                        onChange={(newValue) => {
                          setFinalApplicantSelected(newValue)
                          handleSelectFinalApplicant(newValue)
                        }}
                        styles={modeSelect}
                      />
                    )}
                  </div>
                </div>
                {finalApplicantSelected && !isIdem && !Submitted && (
                  <div
                    className='d-flex align-items-center justify-content-center cursor-pointer p-4'
                    onClick={() => {
                      setFinalApplicantSelected(null)
                      npform2.setFieldValue('FinalApplicantGuid', '')
                      npform2.setFieldValue('FinalApplicantLastname', '')
                      npform2.setFieldValue('FinalApplicantPhone', '')
                      npform2.setFieldValue('FinalApplicantEmail', '')
                      npform2.setFieldValue('FinalApplicantFirstname', '')
                      npform2.setFieldValue('FinalApplicantFunction', '')
                      npform2.setFieldValue('FinalApplicantMobile', '')
                    }}
                    style={clearable}
                  >
                    <i className='fa fa-close text-danger'></i>
                  </div>
                )}
              </div>
              {npform2.touched.FinalApplicantGuid && npform2.errors.FinalApplicantGuid && (
                <div className='is-invalid text-danger'>{npform2.errors.FinalApplicantGuid}</div>
              )}
              <div className='gap-5 d-flex justify-content-between flex-1 mt-5'>
                <div style={{flex: 0.5}}>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'LASTNAME'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'LASTNAME'})}
                      className='form-control form-control-solid'
                      {...npform2.getFieldProps('FinalApplicantLastname')}
                      disabled={isIdem}
                    />
                    {npform2.touched.FinalApplicantLastname &&
                      npform2.errors.FinalApplicantLastname && (
                        <div className='is-invalid text-danger'>
                          {npform2.errors.FinalApplicantLastname}
                        </div>
                      )}
                  </div>
                  <div className='mb-5'>
                    <CustomLabel text={intl.formatMessage({id: 'PHONE_NUMBER'})} />
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'PHONE_NUMBER'})}
                      className='form-control form-control-solid'
                      {...npform2.getFieldProps('FinalApplicantPhone')}
                      disabled={isIdem || Submitted}
                    />
                    {npform2.touched.FinalApplicantPhone && npform2.errors.FinalApplicantPhone && (
                      <div className='is-invalid text-danger'>
                        {npform2.errors.FinalApplicantPhone}
                      </div>
                    )}
                  </div>
                  <div>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'EMAIL'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'EMAIL'})}
                      className='form-control form-control-solid mb-5'
                      {...npform2.getFieldProps('FinalApplicantEmail')}
                      disabled={isIdem || Submitted}
                    />
                    {npform2.touched.FinalApplicantEmail && npform2.errors.FinalApplicantEmail && (
                      <div className='is-invalid text-danger'>
                        {npform2.errors.FinalApplicantEmail}
                      </div>
                    )}
                  </div>
                </div>
                <div style={{flex: 0.5}}>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'FIRSTNAME'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'FIRSTNAME'})}
                      className='form-control form-control-solid'
                      {...npform2.getFieldProps('FinalApplicantFirstname')}
                      disabled={isIdem || Submitted}
                    />
                    {npform2.touched.FinalApplicantFirstname &&
                      npform2.errors.FinalApplicantFirstname && (
                        <div className='is-invalid text-danger'>
                          {npform2.errors.FinalApplicantFirstname}
                        </div>
                      )}
                  </div>
                  <div className='mb-5'>
                    <div className='d-flex'>
                      <CustomGroupeLabel text={intl.formatMessage({id: 'MOBILE_PHONE'})} />
                      <Required className='mx-2' styles={{top: -5}} />
                    </div>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'MOBILE_PHONE'})}
                      className='form-control form-control-solid'
                      {...npform2.getFieldProps('FinalApplicantMobile')}
                      disabled={isIdem || Submitted}
                    />
                    {npform2.touched.FinalApplicantMobile &&
                      npform2.errors.FinalApplicantMobile && (
                        <div className='is-invalid text-danger'>
                          {npform2.errors.FinalApplicantMobile}
                        </div>
                      )}
                  </div>
                  <div className='mb-5'>
                    <CustomLabel text={intl.formatMessage({id: 'WORK_FUNCTION'})} />
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'WORK_FUNCTION'})}
                      className='form-control form-control-solid'
                      {...npform2.getFieldProps('FinalApplicantFunction')}
                      disabled={isIdem || Submitted}
                    />
                    {npform2.touched.FinalApplicantFunction &&
                      npform2.errors.FinalApplicantFunction && (
                        <div className='is-invalid text-danger'>
                          {npform2.errors.FinalApplicantFunction}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{flex: 0.5}}>
            <div className='d-flex'>
              <CustomGroupeLabel text={intl.formatMessage({id: 'MOTIVATIONS'})} />
              <Required className='mx-2' styles={{top: -5}} />
            </div>
            <div className='d-flex align-items-center mb-5'>
              <div style={{flex: 1}}>
                <div className='w-100 position-relative ' data-bs-theme={mode}>
                  {Submitted ? (
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'MOTIVATIONS'})}
                      value={wsSelected?.label || ''}
                      className='form-control form-control-solid'
                    />
                  ) : (
                    <Select
                      className='form-select-solid'
                      options={wsoptions}
                      value={wsSelected}
                      onChange={handleSelectTypeConstruction}
                      styles={modeSelect}
                      isDisabled={Submitted}
                    />
                  )}
                </div>
              </div>
              {wsSelected && !Submitted && (
                <div
                  className='d-flex align-items-center justify-content-center cursor-pointer p-4'
                  onClick={() => {
                    setWsSelected(null)
                    // npform2.values.WorkSiteTypeGuid
                    npform2.setFieldValue('WorkSiteTypeGuid', '')
                  }}
                  style={clearable}
                >
                  <i className='fa fa-close text-danger'></i>
                </div>
              )}
            </div>
            {npform2.touched.WorkSiteTypeGuid && npform2.errors.WorkSiteTypeGuid && (
              <div className='is-invalid text-danger'>{npform2.errors.WorkSiteTypeGuid}</div>
            )}
            <div className='mb-5'>
              <CustomLabel text={intl.formatMessage({id: 'OTHER'})} />
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'OTHER'})}
                className='form-control form-control-solid fst-italic'
                {...npform2.getFieldProps('WorkSiteTypeOther')}
                onChange={(e) => {
                  npform2.setFieldValue('WorkSiteTypeOther', e?.target?.value || '')
                  setWsSelected(null)
                  npform2.setFieldValue('WorkSiteTypeGuid', '')
                }}
                disabled={Submitted}
              />
              {npform2.touched.WorkSiteTypeGuid && npform2.errors.WorkSiteTypeGuid && (
                <div className='is-invalid text-danger'>{npform2.errors.WorkSiteTypeGuid}</div>
              )}
            </div>
            <CustomLabel
              text={intl.formatMessage({id: 'TO_FILL_IF_ONLY_NEW_TYPE'})}
              className='text-gray-500 fw-400 fs-5 mb-5'
            />

            <div className='d-flex'>
              <CustomGroupeLabel text={intl.formatMessage({id: 'PLACE_OF_PROJECT'})} />
              {/* <div className='mx-2' style={{top: -5}}>
                <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
              </div> */}
            </div>
            <div className='mb-5'>
              <CustomLabel text={intl.formatMessage({id: 'ADDRESS_1'})} />
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'ADDRESS_1'})}
                className='form-control form-control-solid'
                {...npform2.getFieldProps('WorkSiteAddress1')}
                disabled={Submitted}
              />
              {/* {npform2.touched.WorkSiteAddress1 && npform2.errors.WorkSiteAddress1 && (
                <div className='is-invalid text-danger'>{npform2.errors.WorkSiteAddress1}</div>
              )} */}
            </div>
            <div className='mb-5'>
              <CustomLabel text={intl.formatMessage({id: 'ADDRESS_2'})} />
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'ADDRESS_2'})}
                className='form-control form-control-solid'
                {...npform2.getFieldProps('WorkSiteAddress2')}
                disabled={Submitted}
              />
              {/* {npform2.touched.WorkSiteAddress2 && npform2.errors.WorkSiteAddress2 && (
                <div className='is-invalid text-danger'>{npform2.errors.WorkSiteAddress2}</div>
              )} */}
            </div>
            <div className='mb-5'>
              <CustomLabel text={intl.formatMessage({id: 'ADDRESS_3'})} />
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'ADDRESS_3'})}
                className='form-control form-control-solid'
                {...npform2.getFieldProps('WorkSiteAddress3')}
                disabled={Submitted}
              />
              {/* {npform2.touched.WorkSiteAddress3 && npform2.errors.WorkSiteAddress3 && (
                <div className='is-invalid text-danger'>{npform2.errors.WorkSiteAddress3}</div>
              )} */}
            </div>
            <div className='gap-2 d-flex justify-content-between flex-1'>
              <div style={{flex: 0.3}} className='mb-5'>
                <CustomLabel text={intl.formatMessage({id: 'POSTAL_CODE'})} />
                <div className='d-flex'>
                  <input
                    type='text'
                    placeholder={intl.formatMessage({id: 'POSTAL_CODE'})}
                    className='form-control form-control-solid'
                    {...npform2.getFieldProps('WorkSitePostalCode')}
                    disabled={Submitted}
                  />
                  <Required styles={{top: 0, left: 5}} />
                </div>
                {npform2.touched.WorkSitePostalCode && npform2.errors.WorkSitePostalCode && (
                  <div className='is-invalid text-danger'>{npform2.errors.WorkSitePostalCode}</div>
                )}
              </div>

              <div style={{flex: 0.7}} className='mb-5 ms-5'>
                <CustomLabel text={intl.formatMessage({id: 'CITY'})} />
                <div className='d-flex align-items-start'>
                  <input
                    type='text'
                    placeholder={intl.formatMessage({id: 'CITY'})}
                    className='form-control form-control-solid'
                    {...npform2.getFieldProps('WorkSiteCity')}
                    disabled={Submitted}
                  />
                  {!Submitted && (
                    <div style={{top: 0, left: 5}}>
                      <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                    </div>
                  )}
                  <Required styles={{top: 0, left: 5}} />
                </div>
                {npform2.touched.WorkSiteCity && npform2.errors.WorkSiteCity && (
                  <div className='is-invalid text-danger'>{npform2.errors.WorkSiteCity}</div>
                )}
              </div>
            </div>
            <div className='d-flex'>
              <div className='d-flex mb-5 align-items-center ' style={{flex: 1}}>
                <div style={{flex: 1}}>
                  <CustomLabel text={intl.formatMessage({id: 'STATE'})} />
                  <div className='w-100 position-relative ' data-bs-theme={mode}>
                    {Submitted ? (
                      <input
                        type='text'
                        value={intervCountry?.label || ''}
                        className='form-control form-control-solid'
                        disabled={Submitted}
                      />
                    ) : (
                      <Select
                        className='form-select-solid'
                        options={countryOprions}
                        value={intervCountry}
                        onChange={handleSelectProjectContrychange}
                        styles={modeSelect}
                        isDisabled={Submitted}
                      />
                    )}
                  </div>
                  {npform2.errors.WorkSiteCountryGuid && (
                    <div className='is-invalid text-danger'>
                      {npform2.errors.WorkSiteCountryGuid}
                    </div>
                  )}
                </div>

                {intervCountry && !Submitted && (
                  <div
                    className='d-flex align-items-center justify-content-center cursor-pointer p-4'
                    onClick={() => {
                      setIntervCountry(null)
                      npform2.setFieldValue('WorkSiteCountryGuid', '')
                    }}
                    style={clearable}
                  >
                    <i className='fa fa-close text-danger'></i>
                  </div>
                )}
              </div>
              <Required styles={{top: 30, left: 5}} />
            </div>
            <CustomGoogleMap
              WorkSiteAddress2={initialWsEdit?.WorkSiteAddress2}
              WorkSiteLatitude={initialWsEdit?.WorkSiteLatitude}
              WorkSiteLongitude={initialWsEdit?.WorkSiteLongitude}
            />
          </div>
        </div>
        <div></div>
        <div className='d-flex justify-content-between pt-4'>
          <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}></span>

          <div className='d-flex'>
            {pGuid && !Submitted && (
              <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}>
                <button
                  type='button'
                  className={
                    'btn btn-dark text-light ' +
                    (isThereModif ? ' cursor-pointer ' : ' not-allowed ')
                  }
                  // style={{backgroundColor: mode === 'dark' ? '#92929f' : '#1b1b29'}}
                  disabled={!isThereModif}
                  onClick={onReset}
                >
                  {intl.formatMessage({id: 'RESET'})}
                </button>
              </span>
            )}
            <div style={{width: 15}} />
            {pGuid && !Submitted && (
              <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}>
                <Button type='submit' variant={'primary'} disabled={!isThereModif}>
                  {intl.formatMessage({id: 'SAVE'})}
                </Button>
              </span>
            )}
            <div style={{width: 15}} />
            {!pGuid && (
              <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}>
                <Button type='submit' variant={'secondary'} disabled={!isThereModif}>
                  {intl.formatMessage({id: 'NEXT'})}
                  <i className='ki-duotone ki-arrow-right fs-1'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                </Button>
              </span>
            )}
            {pGuid && (
              <>
                <Button type='button' variant={'secondary'} onClick={onNextWithoutSaveClick}>
                  {intl.formatMessage({id: 'SUIVANT'})}
                  <i className='ki-duotone ki-arrow-right fs-1'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                </Button>
              </>
            )}
          </div>
        </div>
      </form>
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              {!loading && (
                <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                  {intl.formatMessage({id: 'YES'})}
                </button>
              )}
              {loading && (
                <button className={'btn btn-primary'} onClick={() => {}}>
                  {'...'}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <Modal show={showbq} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div
                className='p-1 cursor-pointer'
                onClick={() => {
                  setShowbq(false)
                }}
              >
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button
                className={'btn btn-secondary'}
                onClick={() => {
                  setShowbq(false)
                }}
              >
                {intl.formatMessage({id: 'NO'})}
              </button>
              {!loading && (
                <button
                  className={'btn btn-primary'}
                  onClick={() => {
                    navigate('/new-project/tab2' + (pGuid ? '/' + pGuid : ''))
                  }}
                >
                  {intl.formatMessage({id: 'YES'})}
                </button>
              )}
              {loading && (
                <button className={'btn btn-primary'} onClick={() => {}}>
                  {'...'}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
      {/* BEFORE_QUIT_CONFIRM_MESSAGE */}
    </div>
  )
}

export default NPTab1Form
